import { useState } from "react";

export function useHelpDialog() {
  const [openHelpDialog, setOpenHelpDialog] = useState(false);
  return {
    openHelpDialog,
    setOpenHelpDialog
  };
}
